import React, { Component } from 'react'

import CollapsibleItem from '../../elements/CollapsibleItem'

class CollapsibleFormList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      itemsStatus: [],
      addingItem: false
    }
  }

  toggleItem = index => {
    const newItemsStatus = this.state.itemsStatus

    newItemsStatus[index] = !newItemsStatus[index]

    this.setState({
      itemsStatus: newItemsStatus
    })
  }

  render() {
    const { itemsStatus } = this.state

    const { onDelete, onUpdate, collapsibleItems, children } = this.props

    return (
      <section>
        {collapsibleItems.map(
          (collapsibleItem, index) =>
            collapsibleItem.document && (
              <CollapsibleItem
                key={collapsibleItem.document}
                label={collapsibleItem.relationship}
                title={collapsibleItem.name}
                active={itemsStatus[index]}
                onClick={() => this.toggleItem(index)}
              >
                {React.cloneElement(children, {
                  form: `representative${collapsibleItem.document}`,
                  initialValues: collapsibleItem,
                  disableKeyFields: true,
                  onDelete:
                    collapsibleItems.length > 1 &&
                    (() => onDelete(collapsibleItem.document, () => this.toggleItem(index))),
                  onSubmit: (...args) => onUpdate(...args, () => this.toggleItem(index)),
                  onCancel: () => this.toggleItem(index)
                })}
              </CollapsibleItem>
            )
        )}
      </section>
    )
  }
}

CollapsibleFormList.defaultProps = {
  collapsibleItems: []
}

export default CollapsibleFormList



// WEBPACK FOOTER //
// ./src/app/modules/CollapsibleFormList/CollapsibleFormList.js